var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fuel-utilization__filters" }, [
    _c(
      "div",
      {
        staticClass:
          "fuel-utilization__filter fuel-utilization__filter--work-orders"
      },
      [
        _c(
          "div",
          { staticClass: "filter__form" },
          [_c("FilterWorkOrderDetails")],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }